initiateFetch